export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5911.326e1262.jpg";